/**
 * Normalizes ForceManager / B4 scalar quirks (booleans, optional FK ids).
 * Imported by domain modules (e.g. productUnitRelations); not re-exported from the package barrel unless needed.
 */

export const getBackendBoolean = (fieldValue) => {
    if (typeof fieldValue === 'boolean') return fieldValue;
    if (fieldValue === 'True' || fieldValue === 'true') return true;
    if (fieldValue === '1' || fieldValue === 1) return true;
    return false;
};

/**
 * Optional id from backend payloads: treat empty and -1 sentinels as null.
 * Use for nullable FK/catalog ids (e.g. unassigned UoM, placeholder entity id).
 *
 * @param {unknown} id
 * @returns {string|null}
 */
export const nullIfBackendEmptyId = (id) => {
    if (id === null || id === undefined || id === '') return null;
    const s = String(id).trim();
    if (s === '' || s === '-1') return null;
    return s;
};

/** Serialize to backend `'1'` / `'0'` strings (inverse of typical boolean parsing). */
export const parseBooleanForBackend = (fieldValue) => {
    if (fieldValue === '1') return fieldValue;
    if (typeof fieldValue === 'boolean' && fieldValue) return '1';
    if (!isNaN(fieldValue) && fieldValue === 1) return '1';
    if (fieldValue === 'True' || fieldValue === 'true') return '1';
    return '0';
};

export const isBackendFalsy = (value) => {
    return !value || value === -1 || value === '-1' || value === 'False' || value === '0';
};

/** First matching property when backend uses inconsistent key casing. */
export const getBackendQuantumValue = (obj, key) => {
    if (obj[key]) return obj[key];
    const quantumStates = [
        key.toLowerCase(),
        key.toUpperCase(),
        key[0].toUpperCase() + key.slice(1),
        key[0].toLowerCase() + key.slice(1),
    ];
    return obj[quantumStates.find((state) => obj[state])];
};
